import { Component, inject, Input } from '@angular/core';
import { ImageService } from '../../../../../services/image/image.service';
import { FormatService } from '../../../../../common/format/format.service';
import { DatePipe } from '@angular/common';
import { SocialChannelEnum } from '../../../../../common/general-types/briefs.dto';
import { summariseBriefAsk } from '@/app/common/brief-ask/summarise-brief-ask';

@Component({
  selector: 'brief-feed-created',
  standalone: true,
  imports: [DatePipe],
  templateUrl: './feed-created.component.html',
  styleUrl: './feed-created.component.css'
})
export class FeedCreatedComponent {

  @Input('activity') activity: any;

  /** Services */
  public formatService = inject(FormatService);
  public imageService = inject(ImageService);
  /** Services END */


  createdAsk() {
    return summariseBriefAsk(this.activity?.brief ?? {});
  }

  getChannelIcon(channel: SocialChannelEnum) {
    switch (channel) {
      case SocialChannelEnum['TikTok Post']:
        return '../../../../../../assets/social-icon/tik-tok-transparent.svg';
      case SocialChannelEnum['Instagram Reel']:
        return '../../../../../../assets/social-icon/ig_reels_logo.png';
      case SocialChannelEnum['Instagram Story']:
        return '../../../../../../assets/social-icon/instagram-logo.png';
      case SocialChannelEnum['YouTube Shorts']:
        return '../../../../../../assets/social-icon/youtube_shorts.webp';
      case SocialChannelEnum['Snapchat Spotlight']:
        return '../../../../../../assets/social-icon/snapchat-logo.svg';
      case SocialChannelEnum['Snapchat Story']:
        return '../../../../../../assets/social-icon/snapchat_story.jpg';
      default:
        return '../../../../../../assets/social-icon/ugc-videos.svg';
    }
  }

  getChannelName(channel: SocialChannelEnum) {
    switch (channel) {
      case SocialChannelEnum['TikTok Post']:
        return 'TikTok Post';
      case SocialChannelEnum['Instagram Reel']:
        return 'Instagram Reel';
      case SocialChannelEnum['YouTube Shorts']:
        return 'YouTube Shorts';
      case SocialChannelEnum['Instagram Story']:
        return 'Instagram Story';
      case SocialChannelEnum['Snapchat Spotlight']:
        return 'Snapchat Spotlight';
      case SocialChannelEnum['Snapchat Story']:
        return 'Snapchat Story';
      default:
        return 'UGC Only';
    }
  }
}
